<div class="container-fluid">
  <div class="row mb-3 align-items-center">
    <div class="col-4">
      <select-field [selectFormControl]="jurisdictionFilterControl" [options]="jurisdictionsOptions"
        label="Filter by jurisdiction">
      </select-field>
    </div>
    @if (hasChangeOfScope) {
      <div class="col-auto change-of-scope-badge-col">
        <span class="badge bg-warning text-primary text-uppercase badge-blink">Change of Scope</span>
      </div>
    }
  </div>

  <div class="row">
    <div class="col-12">
      <ul class="nav nav-tabs">
        @for (tab of tabs; track tab.id) {
          @if (isTabVisible(tab.id)) {
            <li class="nav-item">
              <a class="nav-link" [class.active]="tab.active" href="javascript:void(0);"
              (click)="activateTab(tab.id)">{{tab.title}}</a>
            </li>
          }
        }
      </ul>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12">
      <div class="tab-content">

        @if (isTabActive('summary')) {
          <div class="tab-pane fade show active" id="summary">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">SUMMARY</h3>
              </div>
              <div class="card-body">
                <projects-summary [projectId]="projectId" [project]="project"
                  (onSummaryUpdated)="onSummaryDataUpdated($event)" />
              </div>
            </div>
          </div>
        }
        @if (isTabActive('documentsRequestedToClient')) {
          <div class="tab-pane fade show active" id="documentsRequestedToClient"
            >
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">DOCUMENTS REQUESTED TO CLIENT</h3>
              </div>
              <div class="card-body">
                <projects-documents-requested-to-client [projectId]="projectId"
                  (onDocumentsRequestedUpdated)="onDocumentsRequestedDataUpdated($event)" />
              </div>
            </div>
          </div>
        }
        @if (isTabActive('projectDocument')) {
          <div class="tab-pane fade show active" id="projectDocument">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">PROJECT DOCUMENT</h3>
              </div>
              <div class="card-body">
                <projects-documents [projectId]="projectId"
                  (onProjectDocumentUpdated)="onProjectDocumentDataUpdated($event)" />
              </div>
            </div>
          </div>
        }
        @if (isTabActive('team')) {
          <div class="tab-pane fade show active" id="team">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">TEAM</h3>
              </div>
              <div class="card-body">
                <projects-team [projectId]="projectId" (onTeamUpdated)="onTeamDataUpdated($event)" />
              </div>
            </div>
          </div>
        }
        @if (isTabActive('listItemsToTest')) {
          <div class="tab-pane fade show active" id="listItemsToTest">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">LIST OF ITEMS TO TEST</h3>
              </div>
              <div class="card-body">
                <projects-list-of-items-to-test [projectId]="projectId" [readonly]="readonly" [jurisdictionId]="jurisdictionFilterControl.value" />
              </div>
            </div>
          </div>
        }
        @if (isTabActive('workingList')) {
          <div class="tab-pane fade show active" id="workingList">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">WORKING LIST</h3>
              </div>
              <div class="card-body">
                <projects-working-list [projectId]="projectId"
                  [jurisdictionId]="jurisdictionFilterControl.value"
                  (onWorkingListUpdated)="onWorkingListDataUpdated($event)" />
              </div>
            </div>
          </div>
        }

        @if (isTabActive('checkList')) {
          <div class="tab-pane fade show active" id="checkList">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">CHECK LIST</h3>
              </div>
              <div class="card-body">
                <projects-checklist [projectId]="projectId" [jurisdictionId]="jurisdictionFilterControl.value" />
              </div>
            </div>
          </div>
        }
        @if (isTabActive('batches')) {
          <div class="tab-pane fade show active" id="batches">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">BATCHES</h3>
              </div>
              <div class="card-body">
                <projects-batch [projectId]="projectId" [jurisdictionId]="jurisdictionFilterControl.value"
                  (onBatchUpdated)="onBatchDataUpdated($event)" />
              </div>
            </div>
          </div>
        }
        @if (isTabActive('testList')) {
          <div class="tab-pane fade show active" id="testList">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">TEST LIST</h3>
              </div>
              <div class="card-body">
                <projects-testlist [projectId]="projectId" [jurisdictionId]="jurisdictionFilterControl.value" (onTestlistUpdated)="onTestlistDataUpdated($event)" (canEditChange)="onTestlistCanEditChange($event)" />
              </div>
            </div>
          </div>
        }
        @if (isTabActive('issues')) {
          <div class="tab-pane fade show active" id="issues">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">ISSUES</h3>
              </div>
              <div class="card-body">
                <projects-issue [projectId]="projectId" [readonly]="readonly" />
              </div>
            </div>
          </div>
        }
        @if (isTabActive('summaryReport')) {
          <div class="tab-pane fade show active" id="summaryReport">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">SUMMARY REPORT</h3>
              </div>
              <div class="card-body">
              </div>
            </div>
          </div>
        }
        @if (isTabActive('finance')) {
          <div class="tab-pane fade show active" id="finance">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">FINANCE</h3>
                <projects-finance-authorization class="ms-auto" [projectId]="projectId" [showActions]="true" />
              </div>
              <div class="card-body">
                <projects-finance [projectId]="projectId" [initialView]="financeInitialView" [syncUrl]="readonly" />
              </div>
            </div>
          </div>
        }
        @if (isTabActive('certificate')) {
          <div class="tab-pane fade show active" id="certificate">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">REPORT</h3>
              </div>
              <div class="card-body">
                <projects-certificate [projectId]="projectId" (onCertificateUpdated)="onCertificateDataUpdated($event)" />
              </div>
            </div>
          </div>
        }
        @if (isTabActive('contractsDocs')) {
          <div class="tab-pane fade show active" id="contractsDocs">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">CONTRACTS & DOCS</h3>
              </div>
              <div class="card-body">
                <projects-contracts-docs [projectId]="projectId"
                (onContractsDocsUpdated)="onContractsDocsDataUpdated($event)"></projects-contracts-docs>
              </div>
            </div>
          </div>
        }
        @if (isTabActive('rtp')) {
          <div class="tab-pane fade show active" id="rtp">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">RTP</h3>
              </div>
              <div class="card-body">
                <projects-rtp [projectId]="projectId" (onRtpUpdated)="onRtpDataUpdated($event)"></projects-rtp>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12 text-end">
        @if (isSaveButtonVisible()) {
          <button type="button" class="btn btn-success" (click)="submitActiveChildForm()">
            <i class="bi bi-save"></i> Save
          </button>
        }
      </div>
    </div>
  </div>
</div>